/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert } from 'react-bootstrap';
import { ss, url, authJsonHeader, parseTimeString, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import WhereField from './WhereField';
import Loading from './Loading';
import { AutocompleteField } from './EscapeForm';
import './CompanySignUpForm.css';

import {
  getLocation,
} from '../../actions';


class CompanySignUpForm extends OzFormComponent {

  static fields = [
    'name',
    'address',
    'url',
    'email',
    'password',
  ];

  state = {};

  componentDidMount() {
    if (this.props.locationId) {
      this.setState({ loading: true });
      this.props.getLocation(this.props.locationId, { silent: true, local: true })
        .then(resp => {
          this.setState({ loading: false, location: resp.obj });
        });
    }
  }

  setWhere(where) {
    console.log('set where', where);
    this.setState({ address: where.name });
  }

  getValues() {
    let values = super.getValues();
    if (this.props.locationId) {
      return {
        locationId: this.props.locationId,
        email: values.email,
        password: values.password,
      };
    } else {
      return values;
    }
  }

  renderInput() {
    if (this.props.locationId) return;

    return (
      <div>
        <div>
          {this.renderFormGroup('Company Name', 'text', 'name', { placeholder: 'Company name' })}
          {/*this.renderFormGroup('Address', 'text', 'address', { placeholder: 'Address' })*/}
          <div className="form-group">
            <WhereField
              onChange={(where) => this.setWhere(where)}
              onSelect={(where) => this.setWhere(where)}
              placeholder="Address"
            />
            {this.renderErrors('address')}
          </div>
          {this.renderFormGroup('Website (optional)', 'url', 'url', { placeholder: 'Website' })}
        </div>
        <div className="inputs-help">
          You can add more locations later
        </div>
      </div>
    );
  }

  renderLocation() {
    if (!this.props.locationId) return;
    let location = this.state.location;
    if (!location) return;

    return (
      <div className="location">
        <div className="company">{location.company}</div>
        <div className="address">{location.address}</div>
        <HelpBlock>You can edit the exact name and address later</HelpBlock>
      </div>
    );
  }

  renderBody() {
    if (this.state.loading) return <Loading center />;

    return (
      <div className="CompanySignUpForm">
        <div className="company-info inputs-block">
          {this.renderInput()}
          {this.renderLocation()}
        </div>
        <div className="login-info inputs-block">
          {this.renderFormGroup('Your email', 'email', 'email', { placeholder: 'Email' })}
          {this.renderFormGroup('Password', 'password', 'password', { placeholder: 'Password' })}
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    getLocation,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CompanySignUpForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/CompanySignUpForm.js
 **/